import { SET_UUID_TOKEN } from '../actionTypes';
import { resetPasswordActions } from '../reducer';

export default (uuid, token) => (dispatch) =>
    dispatch(resetPasswordActions[SET_UUID_TOKEN]({ uuid, token }));
